import store from '@/store';
import { BIZAI_EVENTS } from '@/modules/aiChat/utils/trackingUtils';

export const SESSION_REPLAY_TRIGGER_EVENTS = [
  BIZAI_EVENTS.CHAT_OPENED,
];

const isDirectBusiness = () => !store.getters['BusinessStore/isPartnerDirectory'];

const canStartSessionRecording = (eventName) => (
  SESSION_REPLAY_TRIGGER_EVENTS.includes(eventName)
  && isDirectBusiness()
  && typeof window.mixpanel?.start_session_recording === 'function'
);

export const maybeStartSessionRecording = (eventName) => {
  if (!canStartSessionRecording(eventName)) return;
  window.mixpanel.start_session_recording();
};
